"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _TranslatedKey = _interopRequireDefault(require("../TranslatedKey"));

var _ValueTextMapping = _interopRequireDefault(require("../ValueTextMapping"));

var _TranslatedMultiMap = _interopRequireDefault(require("../TranslatedMultiMap"));

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

var JobofferDescriptionLine = function JobofferDescriptionLine(_ref) {
  var header = _ref.header,
      text = _ref.text,
      index = _ref.index,
      discriminator = _ref.discriminator;
  return text.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Grid.default, {
    item: true,
    xs: 12,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
      className: _styleModule.default.headline,
      children: typeof header == 'string' ? header : /*#__PURE__*/(0, _jsxRuntime.jsx)(_TranslatedKey.default, (0, _extends2.default)({
        common: header.common,
        discriminator: discriminator
      }, header), 'h' + header.tKey + index)
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: _styleModule.default.text,
      children: typeof text == 'string' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_ValueTextMapping.default, {
        text: text
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_TranslatedMultiMap.default, (0, _extends2.default)({
        text: text,
        header: header,
        discriminator: discriminator
      }, text), 't' + header.tKey + index)
    })]
  }, 'grtxt' + index);
};

var _default = JobofferDescriptionLine;
exports.default = _default;